import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { mkConfig, generateCsv, download } from 'export-to-csv';
import { jsPDF } from 'jspdf';
import jsonToTable from 'json-to-table';
import GrillaEffect from 'views/Grillas/GrillaEffect';
import dayjs from 'dayjs';
import DataLabel from 'views/Cards/DataLabel';

function DeudaVencida() {
  const defaultFecha = [
    { id: 'periodo_vto', value: dayjs().subtract(1, 'month').format('YYYY-MM'), col_ori: 'a.FactFec' }
  ];
  const [data, setData] = useState([]);
  const [filters, setFilters] = useState([]);

  const csvConfig = mkConfig({
    fieldSeparator: ',',
    decimalSeparator: '.',
    useKeysAsHeaders: true,
  });
  const GenerarCsv = async () => {
    try {
      const baseURL = `${process.env.REACT_APP_API_URL}/querysext/20`;
      const rest = await fetch(baseURL, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('token'),
        },
        body: JSON.stringify({
          fdesde: new Date(startDate).toLocaleDateString(),
          fhasta: new Date(endDate).toLocaleDateString()
        })
      });
      const resulte = await rest.json();
      const csv = generateCsv(csvConfig)(resulte);
      download(csvConfig)(csv);
    } catch (error) {
      console.error(`Error al  generar csv : ${error.message}`);
      throw error;
    }
  };

  const GenerarPdf = async () => {
    try {
      const baseURL = `${process.env.REACT_APP_API_URL}/querysext/20`;
      const rest = await fetch(baseURL, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('token'),
        },
        body: JSON.stringify({
          fdesde: new Date(startDate).toLocaleDateString(),
          fhasta: new Date(endDate).toLocaleDateString()
        })
      });
      const resulte = await rest.json();
      const tabled = jsonToTable(resulte);
      let nombresCampos = tabled[0];
      const doc = new jsPDF();
      doc.autoTable({
        head: [nombresCampos],
        body: tabled,
        margin: { top: 10 },
        styles: {
          minCellHeight: 4,
          halign: 'left',
          valign: 'center',
          fontSize: 4,
        },
      });
      doc.save('pdf-cobranzas.pdf');
    } catch (error) {
      console.error(`Error al  generar csv : ${error.message}`);
      throw error;
    }
  };

  const columnNames = {
    grupo_organismos: { caption: 'Gpo. Organismos', enableColumnFilter: true },
    categoria: { caption: 'Tarifa', enableColumnFilter: true },
    importe_deuda: { caption: 'Deuda', enableColumnFilter: false },
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', pt: '120px' }}>
      <Card>
        <CardBody>
          {/* KPI Cards */}
          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid item xs={12} sm={6} md={4}>
              <Card minH='110px'>
                <CardBody px='2px'>
                  <DataLabel url={`${process.env.REACT_APP_API_URL}/querysextgrilla/?id=` + 70}
                    filters={filters} label={"TOTAL DEUDA VENCIDA"} />
                </CardBody>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Card minH='110px'>
                <CardBody px='2px'>
                  <DataLabel url={`${process.env.REACT_APP_API_URL}/querysextgrilla/?id=` + 69}
                    filters={filters} label={"PARTICULARES"} />
                </CardBody>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Card minH='110px'>
                <CardBody px='2px'>
                  <DataLabel url={`${process.env.REACT_APP_API_URL}/querysextgrilla/?id=` + 68}
                    filters={filters} label={"MUNICIPALIDAD"} />
                </CardBody>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Card minH='110px'>
                <CardBody px='2px'>
                  <DataLabel url={`${process.env.REACT_APP_API_URL}/querysextgrilla/?id=` + 67}
                    filters={filters} label={"PROVINCIA"} />
                </CardBody>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Card minH='110px'>
                <CardBody px='2px'>
                  <DataLabel url={`${process.env.REACT_APP_API_URL}/querysextgrilla/?id=` + 66}
                    filters={filters} label={"NACION"} />
                </CardBody>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Card minH='110px'>
                <CardBody px='2px'>
                  <DataLabel url={`${process.env.REACT_APP_API_URL}/querysextgrilla/?id=` + 72}
                    filters={filters} label={"OTROS"} />
                </CardBody>
              </Card>
            </Grid>
          </Grid>

          {/* BOTONES EXPORTAR — pendiente activar
          <Grid item xs={12} sm={6} md={4}>
            <Card minH='110px'>
              <CardBody>
                (botones futuros aquí)
              </CardBody>
            </Card>
          </Grid>
          */}
          <Card sx={{ p: 2, my: 3 }}>
            <CardBody>
              <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
                <GrillaEffect
                  data={data} updateData={setData}
                  filters={filters} updateFilters={setFilters}
                  idRemoto={65}
                  colsHeaders={columnNames} />
              </LocalizationProvider>
            </CardBody>
          </Card>
        </CardBody>
      </Card>
    </Box>
  );
}

export default DeudaVencida;
